// src/helpers/storageCompat.js
import firebase from "firebase/compat/app";
import "firebase/compat/storage";

/** Root ref to the actual default bucket, independent of naming scheme. */
export function bucketRootRef() {
  const app = firebase.app();
  const cfgBucket = app.options.storageBucket;         // e.g. barterx-swap.firebasestorage.app
  const projectId = app.options.projectId;             // e.g. barterx-swap
  const bucket = cfgBucket || `${projectId}.firebasestorage.app`;
  return firebase.storage().refFromURL(`gs://${bucket}`);
}
